function s(o) {
  return o.split(" ").map((t) => t[0].toUpperCase() + t.substring(1)).join(" ");
}
export {
  s as capitalizeEachWord
};
